import { Container, Row, Col } from "react-bootstrap";
import { Linkedin, Github, Diagram3Fill } from "react-bootstrap-icons";
import React from "react";

export const Footer = () => {
  const socialLinks = [
    {
      href: "https://www.linkedin.com/in/sachin-saurabh/",
      icon: <Linkedin size={30} color={"rgba(170, 54, 124)"} />,
    },
    {
      href: "https://github.com/RaviSachinCodingLife",
      icon: <Github size={30} color={"rgba(170, 54, 124)"} />,
    },
    {
      href: "https://linktr.ee/ravicodinglife",
      icon: <Diagram3Fill size={30} color={"rgba(170, 54, 124)"} />,
    },
  ];

  return (
    <footer className="footer">
      <Container>
        <Row
          className="align-items-center"
          style={{
            padding: "20px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Col
            size={12}
            sm={6}
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              margin: "auto",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "20px",
              }}
            >
              {socialLinks.map((link, index) => (
                <a
                  key={index}
                  role="button"
                  href={link.href}
                  style={{
                    transition: "transform 0.3s ease, filter 0.3s ease",
                  }}
                >
                  {link.icon}
                </a>
              ))}
            </div>
            <p class="text-sm">
              © Portfolio Developed by{" "}
              <a
                target="_blank"
                class="text-[#16f2b3]"
                href="https://www.linkedin.com/in/shahidkhan23/"
                style={{
                  textDecoration: "none",
                  outline: "none",
                  color: "rgb(22 242 179",
                }}
              >
                Sachin Saurabh
              </a>
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
